import { BorrowerEntity, LoanApplicationBorrower } from "@eave/shared/types/api";

import APIClient from "web_modules/APIClient";

export interface BorrowerDelta {
  first_name: string | null;
  last_name: string | null;
  middle_name: string | null;
  suffix: string | null;
  relationship_status: string | null;
  email: string | null;
  dob: string | null;
  phone: string | null;
  estimated_monthly_income: number | null;
}

export const updateLoanApp = (
  appId: number,
  be: BorrowerEntity,
  values: BorrowerDelta,
): Promise<void> => {
  if (be === BorrowerEntity.Borrower1 || be === BorrowerEntity.Borrower2) {
    const appValues = {
      [`borrower${be}_first_name`]: values.first_name,
      [`borrower${be}_last_name`]: values.last_name,
      [`borrower${be}_middle_name`]: values.middle_name,
      [`borrower${be}_suffix`]: values.suffix,
      [`borrower${be}_relationship_status`]: values.relationship_status,
      [`borrower${be}_email`]: values.email,
      [`borrower${be}_dob`]: values.dob,
      [`borrower${be}_phone`]: values.phone,
      [`borrower${be}_estimated_monthly_income`]: Number(values.estimated_monthly_income),
    };
    return APIClient.put(`/loan_applications/${appId}`, appValues);
  }
  return Promise.resolve();
};

export const updateLoanAppBorrower = (
  appId: number,
  borrowerEntity: BorrowerEntity,
  borrower: LoanApplicationBorrower,
  borrowerValues: BorrowerDelta,
): Promise<void> => {
  return APIClient.put(
    `/uw/loan_applications/${appId}/loan_application_borrowers/entity/${borrowerEntity}`,
    {
      borrower: {
        ...borrower,
        ...borrowerValues,
        estimated_monthly_income: Number(borrowerValues.estimated_monthly_income),
      },
    },
  );
};
